/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import forEach from 'lodash/forEach';

var Config: any = require('../../Config.json');
var self;

export interface Reefers {
    ReeferIds: [];
    CommonBookingData: server.CommonBookingData;
    BookingReefers: server.BookingSearchDetails;
    rowData: server.bookingReefer[];
    CustomerGroups: any;
    Thirdparty: server.ThirdParty[];
    RefTemperatureUnit: server.RefTemperatureUnit[];
    editingId: any;
    CargoCareProfiles: any[];
}

var emptyBookingReefers: server.BookingSearchDetails = {
    BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[]
}


var self;


export class SpecificBookingReeferCommonData extends React.Component<any, Reefers> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        var emptyCommonBookingData: server.CommonBookingData = {
                ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim(), BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: true, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
                CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
                O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        var emptyCreateCommonBookingData: server.CommonBookingData = {
            ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim(), BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: this.props.formState.CommonBookingData.ThirdPartyAccess, CACTNotRequired: true, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
            CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
            O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        var propsBookingReefers: server.BookingSearchDetails = {
            BookingReefers: this.props.formState.BookingReefers.BookingReefers, SelectedBookingReefers: this.props.formState.BookingReefers.SelectedBookingReefers,
            ReeferwithUnitID: this.props.formState.BookingReefers.ReeferwithUnitID, BookingNumber: props.formState.BookingReefers.BookingNumber //  RCNG-4345 Fix
            
        }

        var reeferstr = this.props.formState.BookingReefers.SelectedBookingReefers;
        var nameArr = reeferstr.split(',');
        this.state = {
            ReeferIds: reeferstr == "" ? [] : nameArr,
            CommonBookingData: this.props.formState.isEdit || this.props.formState.CopyBookingNumber != ''  ? this.props.formState.CommonBookingData : emptyCommonBookingData,
            BookingReefers: propsBookingReefers,
            rowData:this.props.formState.rowData,
            CustomerGroups: [],
            Thirdparty: [],
            RefTemperatureUnit: [],
            editingId: null,
            CargoCareProfiles: []

        };
        this.loadCustomerGroups();
        this.getRefTemperatureUnit();
        this.getCustomerCargoCareProfiles();
        self = this;
        
    }
    getCustomerCargoCareProfiles() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfiles');
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<any[]>)
                .then(data => {
                    this.setState({ CargoCareProfiles: data });
                });
    }
    getRefTemperatureUnit() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetRefTemperatureUnit')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTemperatureUnit[]>)
            .then(data => {
                this.setState({ RefTemperatureUnit: data });
            });
    }
    loadCustomerGroups() {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetCustomerGroups');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.Customers[]>)
            .then(data => {
                var it = [];
                forEach(data, function (item) {
                    forEach(item.children, function (iteminItem) {
                        if (iteminItem.value != undefined && iteminItem.value != null) {
                            var numItem = iteminItem.value;
                            var splittednumItem = numItem.split(":");
                            var displayLabel = iteminItem.label + "- (" + item.label + ")";
                            var newThirdparty: server.ThirdParty = { ThirdPartyCd: splittednumItem[1], ThirdPartyName: displayLabel };
                            it.push(newThirdparty);
                        }
                    });
                });
                this.setState({ Thirdparty: it });
                this.setState({ CustomerGroups: JSON.parse(JSON.stringify(data)) }, () => $('#globalLoader').hide());
            });
    }
    componentDidMount() {
        if (this.props.formState.isEdit || this.props.formState.CopyBookingNumber != '') {
             var commonBookingData = this.props.formState.CommonBookingData;
            if (commonBookingData.CACTNotRequired == true || commonBookingData.CACTNotRequired == 'true') {
                this.CACTShowHide('CACTNotRequired');
            } else if (commonBookingData.CTRequire == true || commonBookingData.CTRequire == 'true') {
                this.CACTShowHide('CTRequire');
            }
            else if (commonBookingData.CARequire == true || commonBookingData.CARequire == 'true') {
                this.CACTShowHide('CARequire');
            }
            else if (commonBookingData.CACTDifferByReefer == true || commonBookingData.CACTDifferByReefer == 'true' ) {
                this.CACTShowHide('CACTDifferByReefer');
            }
            else if (!commonBookingData.CTRequire == true && !commonBookingData.CARequire== true) {
                if (commonBookingData.O2SetPoint == null &&
                    commonBookingData.O2Min == null &&
                    commonBookingData.O2Max == null &&
                    commonBookingData.CO2SetPoint == null  &&
                    commonBookingData.CO2Min == null  &&
                    commonBookingData.CO2Max == null  &&
                    commonBookingData.CTDays == null  &&
                    commonBookingData.CTMaxTemperature == null  &&
                    commonBookingData.PostCTTemperature == null  &&
                    commonBookingData.PostCTTemperatureRange == null  &&
                    commonBookingData.PostCTVentSettings == null ) {
                    this.CACTShowHide('CACTNotRequired');
                   
                } else {
                    this.CACTShowHide('CACTDifferByReefer');
                }
            }
            // var commonBookingData = this.state.CommonBookingData;
            commonBookingData.ReeferIds = this.props.formState.BookingReefers.ReeferwithUnitID;
            this.setState({
                CommonBookingData: commonBookingData
            });
        }
        if (!(this.props.formState.isEdit)) {
            commonBookingData = this.props.formState.CommonBookingData;
            commonBookingData.ReeferIds = this.props.formState.BookingReefers.ReeferwithUnitID;
            if (commonBookingData.CACTNotRequired == false && commonBookingData.CACTDifferByReefer == false && commonBookingData.CTRequire == false && commonBookingData.CARequire == false && this.state.CommonBookingData.CACTDifferByReefer== false) {
                commonBookingData.CACTNotRequired = true;
                commonBookingData.BookedTemperatureUnit = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
                $('#CTRequire1').hide();
                $('#CTRequire2').hide();
                $('#CARequire1').hide();
                $('#CARequire2').hide();
            } else {
                if (commonBookingData.CACTNotRequired) {
                    this.CACTShowHide('CACTNotRequired');
                } else if (commonBookingData.CTRequire) {
                    this.CACTShowHide('CTRequire');
                }
                else if (commonBookingData.CARequire) {
                    this.CACTShowHide('CARequire');
                }
                else {
                        this.CACTShowHide('CACTDifferByReefer');
                    }
            }
                
                   
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
        }
       
    }
    componentWillReceiveProps(nextProps: any) {
        var commonBookingData = nextProps.formState.CommonBookingData;
        var BookingReefersDetails = emptyBookingReefers;
        BookingReefersDetails.BookingReefers = this.props.formState.BookingReefers.BookingReefers;
        BookingReefersDetails.SelectedBookingReefers = this.props.formState.BookingReefers.SelectedBookingReefers;
        this.setState({ CommonBookingData: commonBookingData, BookingReefers: BookingReefersDetails });
    }

    onCellValueChanged = (params) => {
        const colId = params.column.getId();
        //if (colId === 'country') {
        //    const selectedCountry = params.data.country;
        //    const selectedCity = params.data.city;
        //    const allowedCities = countyToCityMap(selectedCountry);
        //    const cityMismatch = allowedCities.indexOf(selectedCity) < 0;
        //    if (cityMismatch) {
        //        params.node.setDataValue('city', null);
        //    }
        //}
    };
    findInBetween(val, min, max) {
        return (val >= min && val <= max);
    }
    HasNonPrintableASCII(Value) {
        const IsMatch = /[^ -~]+/;
        if (IsMatch.test(Value))
            return true;
        else
            return false;
    }
    ValidateCommonReeferData() {
        //const splCharRegex = new RegExp(/^[a-zA-Z0-9]+$/);//not allow spicial charectors
        if (self.state.CommonBookingData.BookedTemperature != '' && self.state.CommonBookingData.BookedTemperature != null && self.state.CommonBookingData.BookedTemperatureMin != '' && self.state.CommonBookingData.BookedTemperatureMin != null && self.state.CommonBookingData.BookedTemperatureMax != '' && self.state.CommonBookingData.BookedTemperatureMax != null) {
            if (!(self.findInBetween(parseFloat(self.state.CommonBookingData.BookedTemperature), parseFloat(self.state.CommonBookingData.BookedTemperatureMin), parseFloat(self.state.CommonBookingData.BookedTemperatureMax)))) {
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature should be between Booked Temperature Min and Booked Temperature Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.BookedTemperature != '' && self.state.CommonBookingData.BookedTemperature != null && self.state.CommonBookingData.BookedTemperatureMin != '' && self.state.CommonBookingData.BookedTemperatureMin != null) {
            if ((parseFloat(self.state.CommonBookingData.BookedTemperature) < parseFloat(self.state.CommonBookingData.BookedTemperatureMin))) {
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature should be greater than Booked Temperature Min.");
                return false;
            }
        }
        if (self.state.CommonBookingData.BookedTemperature != '' && self.state.CommonBookingData.BookedTemperature != null && self.state.CommonBookingData.BookedTemperatureMax != '' && self.state.CommonBookingData.BookedTemperatureMax != null) {
            if ((parseFloat(self.state.CommonBookingData.BookedTemperature) > parseFloat(self.state.CommonBookingData.BookedTemperatureMax))) {
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature should be less than Booked Temperature Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.BookedTemperatureMin != '' && self.state.CommonBookingData.BookedTemperatureMin != null ) {
            if(!self.findInBetween(parseFloat(self.state.CommonBookingData.BookedTemperatureMin),-100,100)){
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature min should be greater than -100 and less than 100.");
                return false;
            }
        }
        if (self.state.CommonBookingData.BookedTemperatureMax != '' && self.state.CommonBookingData.BookedTemperatureMax != null) {
            if(!self.findInBetween(parseFloat(self.state.CommonBookingData.BookedTemperatureMax),-100,100)){
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature max should be less than 100 and greater than -100.");
                return false;
            }
        }
        if (self.state.CommonBookingData.BookedTemperature != '' && self.state.CommonBookingData.BookedTemperature != null) {
            if(!self.findInBetween(parseFloat(self.state.CommonBookingData.BookedTemperature),-100,100)){
                PopupWindow.showErrorMessage("Booking CommonData", "Booking Tempature should be between -100 to 100");
                return false;
            }
        }

        if (self.state.CommonBookingData.CO2SetPoint != '' && self.state.CommonBookingData.CO2SetPoint != null && self.state.CommonBookingData.CO2Min != '' && self.state.CommonBookingData.CO2Min != null && self.state.CommonBookingData.CO2Max != '' && self.state.CommonBookingData.CO2Max != null) {
            if (!(self.findInBetween(parseFloat(self.state.CommonBookingData.CO2SetPoint), parseFloat(self.state.CommonBookingData.CO2Min), parseFloat(self.state.CommonBookingData.CO2Max)))) {
                PopupWindow.showErrorMessage("Booking CommonData", "CO2 Setpoint should be between Co2 Min and Co2 Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.CO2SetPoint != '' && self.state.CommonBookingData.CO2SetPoint != null && self.state.CommonBookingData.CO2Min != '' && self.state.CommonBookingData.CO2Min != null) {
            if ((parseFloat(self.state.CommonBookingData.CO2SetPoint) < parseFloat(self.state.CommonBookingData.CO2Min))) {
                PopupWindow.showErrorMessage("Booking CommonData", "CO2 Setpoint should be greater than Co2 Min.");
                return false;
            }
        }
        if (self.state.CommonBookingData.CO2SetPoint != '' && self.state.CommonBookingData.CO2SetPoint != null && self.state.CommonBookingData.CO2Max != '' && self.state.CommonBookingData.CO2Max != null) {
            if ((parseFloat(self.state.CommonBookingData.CO2SetPoint) > parseFloat(self.state.CommonBookingData.CO2Max))) {
                PopupWindow.showErrorMessage("Booking CommonData", "CO2 Setpoint should be less than Co2 Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.CO2Min != '' && self.state.CommonBookingData.CO2Min != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.CO2Min), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Co2 Min should be greater than 0 and less than 25.");
                return false;
            }
        }
        if (self.state.CommonBookingData.CO2Max != '' && self.state.CommonBookingData.CO2Max != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.CO2Max), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Co2 Max should be greater than 0 and less than 25.");
                return false;
            }
        }
        if (self.state.CommonBookingData.CO2SetPoint != '' && self.state.CommonBookingData.CO2SetPoint != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.CO2SetPoint), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "CO2 Setpoint should be between 0 to 25");
                return false;
            }
        }

        if (self.state.CommonBookingData.O2SetPoint != '' && self.state.CommonBookingData.O2SetPoint != null && self.state.CommonBookingData.O2Min != '' && self.state.CommonBookingData.O2Min != null && self.state.CommonBookingData.O2Max != '' && self.state.CommonBookingData.O2Max != null) {
            if (!(self.findInBetween(parseFloat(self.state.CommonBookingData.O2SetPoint), parseFloat(self.state.CommonBookingData.O2Min), parseFloat(self.state.CommonBookingData.O2Max)))) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Setpoint should be between O2 Min and O2 Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.O2SetPoint != '' && self.state.CommonBookingData.O2SetPoint != null && self.state.CommonBookingData.O2Min != '' && self.state.CommonBookingData.O2Min != null) {
            if ((parseFloat(self.state.CommonBookingData.O2SetPoint) < parseFloat(self.state.CommonBookingData.O2Min))) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Setpoint should be greater than O2 Min.");
                return false;
            }
        }
        if (self.state.CommonBookingData.O2SetPoint != '' && self.state.CommonBookingData.O2SetPoint != null && self.state.CommonBookingData.O2Max != '' && self.state.CommonBookingData.O2Max != null) {
            if ((parseFloat(self.state.CommonBookingData.O2SetPoint) > parseFloat(self.state.CommonBookingData.O2Max))) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Setpoint should be less than O2 Max.");
                return false;
            }
        }
        if (self.state.CommonBookingData.O2Min != '' && self.state.CommonBookingData.O2Min != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.O2Min), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Min should be greater than 0 and less than 25.");
                return false;
            }
        }
        if (self.state.CommonBookingData.O2Max != '' && self.state.CommonBookingData.O2Max != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.O2Max), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Max should be greater than 0 and less than 25.");
                return false;
            }
        }
        if (self.state.CommonBookingData.O2SetPoint != '' && self.state.CommonBookingData.O2SetPoint != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.O2SetPoint), 0, 25)) {
                PopupWindow.showErrorMessage("Booking CommonData", "O2 Setpoint should be between 0 to 25");
                return false;
            }
        }

        if (self.state.CommonBookingData.HumiditySetPoint != '' && self.state.CommonBookingData.HumiditySetPoint != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.HumiditySetPoint), 0, 100)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Humidity SetPoint should be between 0 to 100");
                return false;
            }
        }
        if (self.state.CommonBookingData.CTDays != '' && self.state.CommonBookingData.CTDays != null) {
                if (!self.findInBetween(parseInt(self.state.CommonBookingData.CTDays), 0, 45)) {
                PopupWindow.showErrorMessage("Booking CommonData", "CT Days should be between 0 to 45");
                return false;
            }
        }
        if (self.state.CommonBookingData.PostCTTemperature != '' && self.state.CommonBookingData.PostCTTemperature != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.PostCTTemperature), -100, 100)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Post-CT Temp should be between -100 to 100");
                return false;
            }
        }
        if (self.state.CommonBookingData.CTMaxTemperature != '' && self.state.CommonBookingData.CTMaxTemperature != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.CTMaxTemperature), -100, 100)) {
                PopupWindow.showErrorMessage("Booking CommonData", "CT Max Temp should be between -100 to 100");
                return false;
            }
        }
        if (self.state.CommonBookingData.PostCTTemperatureRange != '' && self.state.CommonBookingData.PostCTTemperatureRange != null) {
            if (!self.findInBetween(parseFloat(self.state.CommonBookingData.PostCTTemperatureRange), 0, 10)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Post-CT Temp Range  should be between 0 to 10");
                return false;
            }
        }
        if (self.state.CommonBookingData.GensetId != '' && self.state.CommonBookingData.GensetId != null ) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.GensetId)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in Genset ID");
                return false;
            }
        }
        if (self.state.CommonBookingData.VentSettings != '' && self.state.CommonBookingData.VentSettings != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.VentSettings)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in Vent Settings");
                return false;
            }
        }
        if (self.state.CommonBookingData.CommodityName != '' && self.state.CommonBookingData.CommodityName != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.CommodityName)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in Commodity Name");
                return false;
            }
        }
        if (self.state.CommonBookingData.STCC != '' && self.state.CommonBookingData.STCC != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.STCC)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in STCC");
                return false;
            }
        }
        if (self.state.CommonBookingData.HSCode != '' && self.state.CommonBookingData.HSCode != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.HSCode)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in HSCode");
                return false;
            }
        }
        if (self.state.CommonBookingData.ServiceLevel != '' && self.state.CommonBookingData.ServiceLevel != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.ServiceLevel)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in Service Level");
                return false;
            }
        }
        if (self.state.CommonBookingData.PostCTVentSettings != '' && self.state.CommonBookingData.PostCTVentSettings != null) {
            if (self.HasNonPrintableASCII(self.state.CommonBookingData.PostCTVentSettings)) {
                PopupWindow.showErrorMessage("Booking CommonData", "Special characters not allowed in Post-CT Vent Settings ");
                return false;
            }
        }
        if (self.state.CommonBookingData.CommodityName != null && self.state.CommonBookingData.CommodityName != '' && self.state.CommonBookingData.CommodityName.length > 0 ) {
            if (self.state.CommonBookingData.CommodityName.length > 1200) {
                PopupWindow.showErrorMessage("Booking CommonData", "CommodityName should not exceed 1200 charectors.");
                return false;
            }
        }
        return true;

    }
    BookedTemperatureChange(event: React.FormEvent<HTMLInputElement>) {

        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        // const numregex = new RegExp(/^[+-]?[0-9]{1,9}(?:\.[0-9]{1})?$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {

             //if (event.currentTarget.value === '' || ((isNaN(parseFloat(event.currentTarget.value)) >= -100.0) && (100.0 >= isNaN(parseFloat(event.currentTarget.value))))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.BookedTemperature = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
                //}
        }
    }
    BookedTemperatureUnitChange(e) {

        var commonBookingData = this.state.CommonBookingData;
        var Value: string = e.currentTarget.value;
        commonBookingData.BookedTemperatureUnit = Value;
        this.setState({
            CommonBookingData: commonBookingData
        });
    }
    BookedTemperatureMinChange(event: React.FormEvent<HTMLInputElement>) {
       const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
             //if (event.currentTarget.value === '' || ((isNaN(parseFloat(event.currentTarget.value)) >= -100.0) && (100.0 >= isNaN(parseFloat(event.currentTarget.value))))) {
                var commonBookingData = this.state.CommonBookingData;
                var Value: string = event.currentTarget.value;
                commonBookingData.BookedTemperatureMin = Value;
                this.setState({
                    CommonBookingData: commonBookingData
                });
            //}
        }
    }
    BookedTemperatureMaxChange(event: React.FormEvent<HTMLInputElement>) {
       const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
             //if (event.currentTarget.value === '' || ((isNaN(parseFloat(event.currentTarget.value)) >= -100.0) && (100.0 >= isNaN(parseFloat(event.currentTarget.value))))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.BookedTemperatureMax = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    HumiditySetPointChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^\d*\.?\d{0,1}$/);//not allow decimal //^[0-9\b]+$
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
            //if (event.currentTarget.value === '' || ((parseInt(event.currentTarget.value) >= 0) && (100 >= parseInt(event.currentTarget.value)))) {
                var commonBookingData = this.state.CommonBookingData;
                var Value: string = event.currentTarget.value;
                commonBookingData.HumiditySetPoint = Value;
                this.setState({
                    CommonBookingData: commonBookingData
                });
            //}
        } 
    }
    VentSettingsChange(event: React.FormEvent<HTMLInputElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.VentSettings = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }
    GensetIdChange(event: React.FormEvent<HTMLInputElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.GensetId = Value;
            this.setState({
                CommonBookingData: commonBookingData
            }); 
    }
    CommodityNameChange(event: React.FormEvent<HTMLTextAreaElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.CommodityName = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }
    STCCChange(event: React.FormEvent<HTMLInputElement>) {
         var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.STCC = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }
    HSCodeChange(event: React.FormEvent<HTMLInputElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.HSCode = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }
    ServiceLevelChange(event: React.FormEvent<HTMLInputElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.ServiceLevel = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }
    onHighValueCargoChange(e) {
         var commonBookingData = this.state.CommonBookingData;
        commonBookingData.HighValueCargo = e.currentTarget.value;
        this.setState({
            CommonBookingData: commonBookingData
        });       
    }
    CargoCareProfileChange(e) {

        var commonBookingData = this.state.CommonBookingData;
        commonBookingData.CargoCareProfile = e.currentTarget.value;
        this.setState({
            CommonBookingData: commonBookingData
        });
    }
    ThirdPartyAccessChange(e) {

        var commonBookingData = this.state.CommonBookingData;
        commonBookingData.ThirdPartyAccess = e.currentTarget.value;
        this.setState({
            CommonBookingData: commonBookingData
        });
    }

    O2SetPointChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
             //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.O2SetPoint = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    O2MinChange(event: React.FormEvent<HTMLInputElement>) {
         const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/); 
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                var commonBookingData = this.state.CommonBookingData;
                var Value: string = event.currentTarget.value;
                commonBookingData.O2Min = Value;
                this.setState({
                    CommonBookingData: commonBookingData
                });
           // }
        }
    }
    O2MaxChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.O2Max = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    CO2SetPointChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.CO2SetPoint = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    CO2MinChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.CO2Min = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    CO2MaxChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/); 
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.CO2Max = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
           // }
        }
    }
    CTDaysChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[0-9\b]+$/);//not allow decimal 
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
           // if (event.currentTarget.value === '' || ((parseInt(event.currentTarget.value) >= 0) && (45 >= parseInt(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.CTDays = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    CTMaxTemperatureChange(event: React.FormEvent<HTMLInputElement>) {
         const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);  
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
              //if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (25.0 >= parseFloat(event.currentTarget.value)))) {
                    var commonBookingData = this.state.CommonBookingData;
                    var Value: string = event.currentTarget.value;
                    commonBookingData.CTMaxTemperature = Value;
                    this.setState({
                        CommonBookingData: commonBookingData
                    });
            //}
        }
    }
    PostCTTemperatureChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/); 
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.PostCTTemperature = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
        }
    }
    PostCTTemperatureRangeChange(event: React.FormEvent<HTMLInputElement>) {
        const numregex = new RegExp(/^[+-]?\d*\.?\d{0,1}$/);  
        if (event.currentTarget.value === '' || numregex.test(event.currentTarget.value)) {
           // if (event.currentTarget.value === '' || ((parseFloat(event.currentTarget.value) >= 0.0) && (10.0 >= parseFloat(event.currentTarget.value)))) {
                var commonBookingData = this.state.CommonBookingData;
                var Value: string = event.currentTarget.value;
                commonBookingData.PostCTTemperatureRange = Value;
                this.setState({
                    CommonBookingData: commonBookingData
                });
           // }
        }
    }
    PostCTVentSettingsChange(event: React.FormEvent<HTMLInputElement>) {
            var commonBookingData = this.state.CommonBookingData;
            var Value: string = event.currentTarget.value;
            commonBookingData.PostCTVentSettings = Value;
            this.setState({
                CommonBookingData: commonBookingData
            });
    }

    UpdateRowdataValues(value) {
         if (value == 'CTRequire') {
                    var data = this.state.rowData;
                       var modefiedRowData = data.map(cd => ({
                           ...cd,
                           cargoCare: cd.cargoCare,
                           accessCodes: cd.accessCodes,
                           bookedTemperature:  cd.bookedTemperature,
                           bookedTemperatureQualifier:cd.bookedTemperatureQualifier,
                           bookedTemperatureMin: cd.bookedTemperatureMin,
                           bookedTemperatureMax: cd.bookedTemperatureMax,
                           humidity: cd.humidity,
                           commodity:  cd.commodity,
                           STCC: cd.STCC,
                           HS: cd.HS,
                           gensetId: cd.gensetId,
                           ventSetting: cd.ventSetting,
                           HVFlag: cd.HVFlag,
                           serviceLevel: cd.serviceLevel,
                           CAFlag:  'false',
                           O2Setpoint: '',
                           O2SetpointMin: '',
                           O2SetpointMax: '',
                           CO2Setpoint: '',
                           CO2SetpointMin: '',
                           CO2SetpointMax: '',
                           CTFlag: cd.CTFlag,
                           CTDays: cd.CTDays,
                           USDAMaxTemperature: cd.USDAMaxTemperature,
                           postCTTemperature: cd.postCTTemperature,
                           postCTTemperatureDeviation: cd.postCTTemperatureDeviation,
                           postCTVentSetting: cd.postCTVentSetting
                    }));
                  
                    this.setState({
                        rowData: modefiedRowData});
            }
         else if(value == 'CARequire'){
                 var data = this.state.rowData;
                    var modefiedRowData = data.map(cd => ({
                        ...cd,
                        cargoCare: cd.cargoCare,
                        accessCodes: cd.accessCodes,
                        bookedTemperature: cd.bookedTemperature,
                        bookedTemperatureQualifier: cd.bookedTemperatureQualifier,
                        bookedTemperatureMin: cd.bookedTemperatureMin,
                        bookedTemperatureMax: cd.bookedTemperatureMax,
                        humidity: cd.humidity,
                        commodity: cd.commodity,
                        STCC: cd.STCC,
                        HS: cd.HS,
                        gensetId: cd.gensetId,
                        ventSetting: cd.ventSetting,
                        HVFlag: cd.HVFlag,
                        serviceLevel: cd.serviceLevel,
                        CAFlag: cd.CAFlag,
                        O2Setpoint: cd.O2Setpoint,
                        O2SetpointMin: cd.O2SetpointMin,
                        O2SetpointMax: cd.O2SetpointMax,
                        CO2Setpoint: cd.CO2Setpoint,
                        CO2SetpointMin: cd.CO2SetpointMin,
                        CO2SetpointMax: cd.CO2SetpointMax,
                        CTFlag: 'false',
                        CTDays: '',
                        USDAMaxTemperature: '',
                        postCTTemperature: '',
                        postCTTemperatureDeviation: '',
                        postCTVentSetting: ''
                    }));
                   
                    this.setState({
                        rowData: modefiedRowData});
                
            }
        else  if (value == 'CACTNotRequired') {
                 var data = this.state.rowData;
                    var modefiedRowData = data.map(cd => ({
                        ...cd,
                        cargoCare: cd.cargoCare,
                        accessCodes: cd.accessCodes,
                        bookedTemperature: cd.bookedTemperature,
                        bookedTemperatureQualifier: cd.bookedTemperatureQualifier,
                        bookedTemperatureMin: cd.bookedTemperatureMin,
                        bookedTemperatureMax: cd.bookedTemperatureMax,
                        humidity: cd.humidity,
                        commodity: cd.commodity,
                        STCC: cd.STCC,
                        HS: cd.HS,
                        gensetId: cd.gensetId,
                        ventSetting: cd.ventSetting,
                        HVFlag: cd.HVFlag,
                        serviceLevel: cd.serviceLevel,
                        CAFlag: 'false',
                        O2Setpoint:'',
                        O2SetpointMin: '',
                        O2SetpointMax: '',
                        CO2Setpoint:'',
                        CO2SetpointMin: '',
                        CO2SetpointMax: '',
                        CTFlag: 'false',
                        CTDays: '',
                        USDAMaxTemperature: '',
                        postCTTemperature: '',
                        postCTTemperatureDeviation: '',
                        postCTVentSetting:''
                    }));
                    this.setState({
                        rowData: modefiedRowData});
            
            }
             else  if (value == 'CACTDifferByReefer') {
                 var data = this.state.rowData;
                    var modefiedRowData = data.map(cd => ({
                        ...cd,
                        cargoCare: cd.cargoCare,
                        accessCodes: cd.accessCodes,
                        bookedTemperature: cd.bookedTemperature,
                        bookedTemperatureQualifier: cd.bookedTemperatureQualifier,
                        bookedTemperatureMin: cd.bookedTemperatureMin,
                        bookedTemperatureMax: cd.bookedTemperatureMax,
                        humidity: cd.humidity,
                        commodity: cd.commodity,
                        STCC: cd.STCC,
                        HS: cd.HS,
                        gensetId: cd.gensetId,
                        ventSetting: cd.ventSetting,
                        HVFlag: cd.HVFlag,
                        serviceLevel: cd.serviceLevel,
                        CAFlag: cd.CAFlag,
                        O2Setpoint: cd.O2Setpoint,
                        O2SetpointMin: cd.O2SetpointMin,
                        O2SetpointMax: cd.O2SetpointMax,
                        CO2Setpoint: cd.CO2Setpoint,
                        CO2SetpointMin: cd.CO2SetpointMin,
                        CO2SetpointMax: cd.CO2SetpointMax,
                        CTFlag: cd.CTFlag,
                        CTDays: cd.CTDays,
                        USDAMaxTemperature: cd.USDAMaxTemperature,
                        postCTTemperature: cd.postCTTemperature,
                        postCTTemperatureDeviation: cd.postCTTemperatureDeviation,
                        postCTVentSetting: cd.postCTVentSetting
                    }));
                    this.setState({
                        rowData: modefiedRowData});
            
            }
    }

    CACTShowHide(value) {
        if (value == 'CTRequire') {
            var commonBookingData = this.state.CommonBookingData;
            commonBookingData.CTRequire = true;
            commonBookingData.CARequire = false;
            commonBookingData.CACTNotRequired = false;
            commonBookingData.CACTDifferByReefer = false;
            commonBookingData.O2SetPoint = '';
            commonBookingData.O2Min = '';
            commonBookingData.O2Max = '';
            commonBookingData.CO2SetPoint = '';
            commonBookingData.CO2Min = '';
            commonBookingData.CO2Max = '';
            this.setState({
                CommonBookingData: commonBookingData
            }, () => {
                $('#CARequire1').hide();
                $('#CARequire2').hide();
                $('#CTRequire1').show();
                $('#CTRequire2').show();
                if (this.props.formState.isEdit || this.props.formState.CopyBookingNumber != '')
                { this.UpdateRowdataValues(value);}
            });
            

        }
        else if (value == 'CARequire') {
            var commonBookingData = this.state.CommonBookingData;
            commonBookingData.CTRequire = false;
            commonBookingData.CARequire = true;
            commonBookingData.CACTNotRequired = false;
            commonBookingData.CACTDifferByReefer = false;
            commonBookingData.CTDays = '';
            commonBookingData.CTMaxTemperature = '';
            commonBookingData.PostCTTemperature = '';
            commonBookingData.PostCTTemperatureRange = '';
            commonBookingData.PostCTVentSettings = '';

            this.setState({
                CommonBookingData: commonBookingData
            }, () => {
                $('#CTRequire1').hide();
                $('#CTRequire2').hide();
                $('#CARequire1').show();
                $('#CARequire2').show();
                if (this.props.formState.isEdit || this.props.formState.CopyBookingNumber != '')
                { this.UpdateRowdataValues(value);}
            });

        }
        else if ((value == 'CACTNotRequired') || (value == 'CACTDifferByReefer')) {
            var commonBookingData = this.state.CommonBookingData;
            if ((value == 'CACTNotRequired')) {
                 if(this.props.formState.isEdit)
                { this.UpdateRowdataValues(value);}
                commonBookingData.CTRequire = false;
                commonBookingData.CARequire = false;
                commonBookingData.CACTNotRequired = true;
                commonBookingData.CACTDifferByReefer = false;
                commonBookingData.O2SetPoint = '';
                commonBookingData.O2Min = '';
                commonBookingData.O2Max = '';
                commonBookingData.CO2SetPoint = '';
                commonBookingData.CO2Min = '';
                commonBookingData.CO2Max = '';
                commonBookingData.CTDays = '';
                commonBookingData.CTMaxTemperature = '';
                commonBookingData.PostCTTemperature = '';
                commonBookingData.PostCTTemperatureRange = '';
                commonBookingData.PostCTVentSettings = '';
            }
            else if (value == 'CACTDifferByReefer') {
                if (this.props.formState.isEdit || this.props.formState.CopyBookingNumber != '')
                { this.UpdateRowdataValues(value);}
                commonBookingData.CTRequire = false;
                commonBookingData.CARequire = false;
                commonBookingData.CACTNotRequired = false;
                commonBookingData.CACTDifferByReefer = true;
                commonBookingData.O2SetPoint = '';
                commonBookingData.O2Min = '';
                commonBookingData.O2Max = '';
                commonBookingData.CO2SetPoint = '';
                commonBookingData.CO2Min = '';
                commonBookingData.CO2Max = '';
                commonBookingData.CTDays = '';
                commonBookingData.CTMaxTemperature = '';
                commonBookingData.PostCTTemperature = '';
                commonBookingData.PostCTTemperatureRange = '';
                commonBookingData.PostCTVentSettings = '';
            }
            this.setState({
                CommonBookingData: commonBookingData
            }, () => {
                $('#CTRequire1').hide();
                $('#CTRequire2').hide();
                $('#CARequire1').hide();
                $('#CARequire2').hide();
            });

        }
    }
    static BackScreen() {
        self.props.renderWizardPage(2, self.props.formState, 3);
    }
    static NextScreen() {

        //if (self.state.ReeferIds != null && self.state.ReeferIds != '' && self.state.ReeferIds != undefined)
        if (self.ValidateCommonReeferData()) {
            self.props.renderWizardPage(4, self.state, 3);
        }

        //else
        //PopupWindow.showErrorMessage("Alert", "Please Select at least one Reefer.");
    }
    public render() {       
        return <div>
           
            <div className="row mt-3">
                <div className="col-md-12">

                    <div className='text-center'>
                        <span className='fw-semibold'>Enter values that apply to all reefers associated with the booking. These values can be changed for each individual reefer in the next step.</span>
                    </div>

                    </div>
            </div>


            <div className="row ">

                <div className="col-md-12 px-0">

                    <hr className="HorizentalLine mt-2" />
                </div>


            </div>


            <div className='Booking3rdtabMargin'>
                <div className="row">
                    <div className="col-md-2 pe-0 text-md-end">
                        <span className='col-form-label'>Reefer IDs:</span>
                    </div>
                    <div className="col-md-9">
                        <div className='ReeferScroll'>

                            {this.state.ReeferIds != undefined && this.state.ReeferIds != null && this.state.ReeferIds.length > 0 ? 
                            this.state.ReeferIds.map(f => <span className='badge bg-dark ms-1 mt-1'>{f}</span>) : '-NA-'}
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Booked Temp ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"}) :</label>
                    </div>
                    <div className="col-md-2">
                        <div className="input-group">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.BookedTemperature} onChange={e => this.BookedTemperatureChange(e)} className='form-control' />
                      
                            <select className='form-select' onChange={e => this.BookedTemperatureUnitChange(e)} value={this.state.CommonBookingData.BookedTemperatureUnit}>
                                {
                                    this.state.RefTemperatureUnit.map((unit, index) =>
                                        <option key={unit.TemperatureUnitCd + index} value={unit.TemperatureUnitCd}>{unit.TemperatureUnitDesc}</option>
                                    )}
                            </select>
                     
                        </div>
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Booked Temp Min ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"})  :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.BookedTemperatureMin} onChange={e => this.BookedTemperatureMinChange(e)} className='form-control' />
                    </div>

                    <div className="col-md-1 px-0 text-md-end">
                        <label className='col-form-label'>Commodity Name :</label>
                    </div>
                    {/*<div className="col-md-2">*/}
                    {/*    <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CommodityName} maxLength={1201} onChange={e => this.CommodityNameChange(e)} className='form-control' title={this.state.CommonBookingData.CommodityName} />*/}
                    {/*</div>*/}

                    <div className="col-md-2">
                        <textarea id="txtAreaCommodityName" className="form-control BookingTextarea" value={this.state.CommonBookingData.CommodityName} maxLength={1201} onChange={e => this.CommodityNameChange(e)}></textarea>
                    </div>
                   
                </div>

                <div className="row mt-2">
                <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Booked Temp Max ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"}) :</label>
                </div>
                <div className="col-md-2">
                    <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.BookedTemperatureMax} onChange={e => this.BookedTemperatureMaxChange(e)} className='form-control' />
                    </div>


                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Genset ID :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.GensetId} maxLength={11} onChange={e => this.GensetIdChange(e)} className='form-control' />
                    </div>

                </div>

                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Humidity Setpoint (%):</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.HumiditySetPoint} onChange={e => this.HumiditySetPointChange(e)} className='form-control' />    
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Vent Settings :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.VentSettings} maxLength={35} onChange={e => this.VentSettingsChange(e)} className='form-control' />
                    </div>

                </div>
                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>HS Code :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.HSCode} maxLength={15} onChange={e => this.HSCodeChange(e)} className='form-control' />
                    </div>
                    
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>STCC :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.STCC} maxLength={7} onChange={e => this.STCCChange(e)} className='form-control' />
                    </div>

                   
                </div>
                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Service Level :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.ServiceLevel} maxLength={10} onChange={e => this.ServiceLevelChange(e)} className='form-control' />
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>High Value Cargo :</label>
                    </div>
                    <div className="col-md-2">                       
                            <select className='form-select' id="cBoxHVFlagChange" name="HVFlag" value={this.state.CommonBookingData.HighValueCargo}
                                onChange={e => this.onHighValueCargoChange(e)} >
                                <option value="none">---None---</option>
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'> CargoCare Profile : </label>
                    </div>
                    <div className="col-md-2">
                        <select className="form-select" id="cBoxCargoCareProfile" name="CargoCareProfile" value={this.state.CommonBookingData.CargoCareProfile}
                            onChange={e => this.CargoCareProfileChange(e)} >
                            <option value="None">---None---</option>
                            {
                                this.state.CargoCareProfiles.map((cp, index) =>
                                    <option key={index} value={cp.CargoCareCustomerProfileCode}>{cp.CargoCareCustomerProfileCode}</option>
                                )
                            }                             
                        </select>
                    </div>
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Third-Party Access :</label>
                    </div>
                    <div className="col-md-2">
                       <select className="form-select" id="cBoxThirdPartyAccess" name="ThirdPartyAccess" value={this.state.CommonBookingData.ThirdPartyAccess}
                            onChange={e => this.ThirdPartyAccessChange(e)} >
                            <option value="-1">---None---</option>
                            {
                                this.state.Thirdparty.map((tP, index) =>
                                    <option key={index} value={tP.ThirdPartyCd}>{tP.ThirdPartyName}</option>
                                )
                            }
                        </select>              
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-2 pe-0 text-md-end">
                        <span className='col-form-label'>CA or CT not required :</span>
                    </div>
                    <div className="col-md-2">
                        <input type="radio" className="radio20" checked={this.state.CommonBookingData.CACTNotRequired} value="CACTNotRequired" onClick={(e) => this.CACTShowHide('CACTNotRequired')} />
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <span className='col-form-label'>Requires CT :</span>
                    </div>
                    <div className="col-md-2">
                        <input type="radio" className="radio20" checked={this.state.CommonBookingData.CTRequire} value="CTRequire" onClick={(e) => this.CACTShowHide('CTRequire')} />
                    </div>


                    <div className="col-md-1 pe-0 text-md-end">
                        <span className='col-form-label'>Requires CA :</span>
                    </div>
                    <div className="col-md-2">
                        <input type="radio" className="radio20" checked={this.state.CommonBookingData.CARequire} value="CARequire" onClick={(e) => this.CACTShowHide('CARequire')} />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <span className='col-form-label'>CA and CT differ by reefer :</span>
                    </div>
                    <div className="col-md-2">
                        <input type="radio" className="radio20" checked={this.state.CommonBookingData.CACTDifferByReefer} value="CACTDifferByReefer" onClick={(e) => this.CACTShowHide('CACTDifferByReefer')} />
                    </div>
                </div>
                <div className="row mt-3" id="CARequire1">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>O2 Setpoint :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.O2SetPoint} onChange={e => this.O2SetPointChange(e)} className='form-control' />
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>O2 Min :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.O2Min} onChange={e => this.O2MinChange(e)} className='form-control' />
                    </div>
                    <div className="col-md-1 pe-0 text-md-end">
                        <label className='col-form-label'>O2 Max :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.O2Max} onChange={e => this.O2MaxChange(e)} className='form-control' />
                    </div>
                </div>
                <div className="row mt-2" id="CARequire2">
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>CO2 Setpoint :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CO2SetPoint} onChange={e => this.CO2SetPointChange(e)} className='form-control' />
                    </div>
                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>CO2 Min :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CO2Min} onChange={e => this.CO2MinChange(e)} className='form-control' />
                    </div>
                    <div className="col-md-1 pe-0 text-md-end">
                        <label className='col-form-label'>CO2 Max :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CO2Max} onChange={e => this.CO2MaxChange(e)} className='form-control' />
                    </div>
                </div>
                <div className="row mt-3" id="CTRequire1">

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>CT Days :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CTDays} onChange={e => this.CTDaysChange(e)} className='form-control' />
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'> USDA Max Temp ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"}) :</label>
                    </div>

                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.CTMaxTemperature} onChange={e => this.CTMaxTemperatureChange(e)} className='form-control' />
                    </div>
                </div>
                <div className="row mt-2" id="CTRequire2">

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'>Post-CT Temp ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"}) :</label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.PostCTTemperature} onChange={e => this.PostCTTemperatureChange(e)} className='form-control' />
                    </div>

                    <div className="col-md-2 pe-0 text-md-end">
                        <label className='col-form-label'> Post-CT Temp Range ({this.state.CommonBookingData.BookedTemperatureUnit == "C" ? "°C" : this.state.CommonBookingData.BookedTemperatureUnit == "F" ? "°F" : "N"}) : </label>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.PostCTTemperatureRange} onChange={e => this.PostCTTemperatureRangeChange(e)} className='form-control' />
                    </div>
                    <div className="col-md-1 pe-0 text-md-end">
                        <span className='col-form-label'>Post-CT Vent Settings : </span>
                    </div>
                    <div className="col-md-2">
                        <input type='text' id='txtDeploymentName' value={this.state.CommonBookingData.PostCTVentSettings} maxLength={35} onChange={e => this.PostCTVentSettingsChange(e)} className='form-control' />
                    </div>


                </div>

            </div>

        </div>;

    }
}


